

























































import { PropType } from 'vue';

import Colorable from '@/mixins/colorable';

import { Quote, ICustomerPricing } from '@/models';

export default Colorable.extend({
  name: 'QuoteCustomerSpecialPricingCard',
  props: {
    quote: Object as PropType<Quote>
  },

  computed: {
    getColor(): string {
      if (this.customerPricing.isValid(this.quote.created_at!))
        return 'warning';
      return 'error';
    },

    getIcon(): string {
      if (this.customerPricing.isValid(this.quote.created_at!))
        return 'mdi-information-variant';
      return 'mdi-alert';
    },

    customerPricing(): ICustomerPricing {
      return this.quote.customer.contract!;
    }
  }
});
